import React, { useEffect, useRef, useState } from 'react'
import { classNameInput, notify } from '../../../../utils/utils'
import { useCentroMonitoreo } from '../../../../hooks/monitoreo/useCentroMonitoreo'

const ContenedorSeguimiento = ({
  fechaInicio = "",
  fechaFin = "",
  codEmpresa = 0,
  codRuta = 0,
  nomRuta = "",
  funcionEjecucion = () => {}
}) => {
  const hookCentroMonitoreo = useCentroMonitoreo()
  const [nuevoSeguimiento, setNuevoSeguimiento] = useState('')
  const inputRegistroRef = useRef(null)

  useEffect(() => {
    hookCentroMonitoreo.listarSeguimientosEmpresa(fechaInicio, fechaFin, codEmpresa, codRuta)
    inputRegistroRef.current.focus()
  },[])
  
  const registrarNuevoSeguimiento = async () => {
    const response = await hookCentroMonitoreo.registrarSeguimientoEmpresa(codEmpresa, codRuta, nomRuta, nuevoSeguimiento)
    notify(response.DesResultado, response.CodResultado == 1 ? 'success' : 'error')
    if(response.CodResultado == 1){
      setNuevoSeguimiento('');
      await hookCentroMonitoreo.listarSeguimientosEmpresa(fechaInicio, fechaFin, codEmpresa, codRuta);
      await funcionEjecucion()
    }
  }

  const eliminarSeguimiento = async (codigoSeguimiento) => {
    const response = await hookCentroMonitoreo.eliminarSeguimientoEmpresa(codigoSeguimiento)
    notify(response.DesResultado, response.CodResultado == 1 ? 'success' : 'error')
    if(response.CodResultado == 1){
      await hookCentroMonitoreo.listarSeguimientosEmpresa(fechaInicio, fechaFin, codEmpresa, codRuta);
      await funcionEjecucion()
    }
  }
  return (
    <div className='max-h-[300px] overflow-auto w-[800px]'>
      <table className='table'>
        <thead>
          <tr>
            <th>Nº</th>
            <th>FECHA</th>
            <th>DESCRIPCIÓN</th>
            <th>USUARIO</th>
            <th className='w-[40px]'></th>
          </tr>
        </thead>
        <tbody>
          {
            hookCentroMonitoreo.seguimientosEmpresa.map((data,i) => (
              <tr key={i+1}>
                <td>{i+1}</td>
                <td>{data.fechaCreacion}</td>
                <td>{data.descripcion}</td>
                <td>{data.uIDCreacion}</td>
                <td><i onClick={() => eliminarSeguimiento(data.codIndicadorSeguimiento)} className='fas fa-trash text-red-600'></i></td>
              </tr>
            ))
          }
          <tr className='!h-[40px]'>
            <td></td>
            <td colSpan={3}>
              <input 
                ref={inputRegistroRef}
                value={nuevoSeguimiento} 
                onInput={e => setNuevoSeguimiento(e.target.value)} 
                className={`${classNameInput} w-full`} type="text" 
              />
            </td>
            <td>
              <button onClick={registrarNuevoSeguimiento} className='rounded-md bg-green-600 w-[35px] h-[25px]'>
                <i className='fas fa-check'></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default ContenedorSeguimiento